<template>
  <div>
    <header>
      <div class="headerDiv">
        <div>
          <img src="../assets/images/fk-icon.png" alt="Forsakringskassan" />
        </div>
        <div class="headerDivNav">
          <router-link to="/dashboard" v-slot="{ href, route, navigate, isActive, isExactActive }">
            <div class="headerDivNavItem" :class="[isActive && 'router-link-active', isExactActive && 'router-link-exact-active']">
              <a :href="href" @click="navigate"><font-awesome-icon :icon="['fas', 'home']" class="navIcon" />Startsida</a>
            </div>
          </router-link>
          <router-link to="/dashboard/fastinsights" v-slot="{ href, route, navigate, isActive, isExactActive }">
            <div class="headerDivNavItem" :class="[isActive && 'router-link-active', isExactActive && 'router-link-exact-active']">
              <a :href="href" @click="navigate"><font-awesome-icon :icon="['far', 'lightbulb']" class="navIcon" />&nbsp;Insikter</a>
            </div>
          </router-link>
          <router-link to="/dashboard/facebook" v-slot="{ href, route, navigate, isActive, isExactActive }">
            <div class="headerDivNavItem" :class="[isActive && 'router-link-active', isExactActive && 'router-link-exact-active']">
              <a :href="href" @click="navigate"><font-awesome-icon :icon="['fab', 'facebook']" class="navIcon" />&nbsp;Facebook</a>
            </div>
          </router-link>
          <router-link to="/dashboard/twitter" v-slot="{ href, route, navigate, isActive, isExactActive }">
            <div class="headerDivNavItem" :class="[isActive && 'router-link-active', isExactActive && 'router-link-exact-active']">
              <a :href="href" @click="navigate"><font-awesome-icon :icon="['fab', 'twitter']" class="navIcon" />&nbsp;Twitter</a>
            </div>
          </router-link>
          <!-- <router-link to="/dashboard/linkedin" v-slot="{ href, route, navigate, isActive, isExactActive }">
            <div class="headerDivNavItem" :class="[isActive && 'router-link-active', isExactActive && 'router-link-exact-active']">
              <a :href="href" @click="navigate"><font-awesome-icon :icon="['fab', 'linkedin']" class="navIcon" />&nbsp;LinkedIn</a>
            </div>
          </router-link> -->
          <router-link to="/dashboard/youtube" v-slot="{ href, route, navigate, isActive, isExactActive }">
            <div class="headerDivNavItem" :class="[isActive && 'router-link-active', isExactActive && 'router-link-exact-active']">
              <a :href="href" @click="navigate"><font-awesome-icon :icon="['fab', 'youtube']" class="navIcon" />&nbsp;YouTube</a>
            </div>
          </router-link>
        </div>
        <div class="headerSignOut">
          &nbsp;
          <!-- <router-link to="/">
            <font-awesome-icon :icon="['fas', 'sign-out-alt']" class="icon" />
          </router-link> -->
        </div>
      </div>
    </header>
    <main>
      <div class="mainContent">
        <div></div>
          <!-- <transition name="router-anim"> -->
            <router-view />
          <!-- </transition> -->
        <div></div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  data () {
    return { }
  },
  mounted () {
    // console.log(this.$router.currentRoute.name)
  },
  computed: { },
  updated () { }
}
</script>

<style>
/* @import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1"; */

.router-anim-enter-active {
  animation: coming .2s;
  animation-delay: .3s;
  opacity: 0;
}
.router-anim-leave-active {
  animation: going .2s;
}

@keyframes going {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}
@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
